@if (data) {
  <div class="confirm-dialog grid-y align-middle">
    <button
      aria-label="Close"
      type="button" class="close-btn" mat-icon-button mat-dialog-close>
      <mat-icon class="close-icon" svgIcon="close-blue"></mat-icon>
    </button>

    <section class="confirm-dialog__header grid-y align-middle">
      <img alt="" src="assets/images/dialog/{{ data.icon }}.svg" />
      <div class="cell">
        <!-- The dialog's name (axe aria-dialog-name): the component points
             its container's aria-labelledby here, for every caller. -->
        <h2 [id]="titleId" class="text-center font-semibold text-2xl">{{ data.title }}</h2>
      </div>
    </section>
    <section>
      @if (data.message) {
        <div class="message">
          {{ data.message }}
        </div>
      }
      <!-- BUTTONS -->
      <div class="actions">
        @if (data.cancelText) {
          <cpd-stroked-button
            color="primary"
            [text]="data.cancelText"
            size="large"
            mat-dialog-close
          >
          </cpd-stroked-button>
        }
        <cpd-flat-button
          color="primary"
          [text]="data.confirmText"
          size="large"
          mat-dialog-close
          (click)="data.confirmFn && data.confirmFn()"
        ></cpd-flat-button>
      </div>
    </section>
  </div>
}
